import { createMachine } from 'xstate';
import api from '@utils/api';
import { auth } from '@src/plugins/Auth';
import { STATUS_TRANSFER_DECLINE } from '@src/const/statusTransferAccount.js';

const transferProfile = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QBcBOBDAdrAZmVACqgPY4CWANmAHQBGZmEDUAxOgA7skBuYA2gAYAuolDtisMsjLFMokAA9EAWgAsADgCs1AQGZdARgMA2AEymB6gJw3jAGhABPFcd3VVVzad031e9cbqupoAviEOaFi4+ESklDT0jMwsEGAAxhQM-MLy4pLSsvJKCPrq1FbGrlYGAsYA7AICmvZOKnWq1LqmqgIGmnWatQaGdWERGNh4hCTkVHQMTJisGRLZIkggeVIychvFykZW1HXGqt4GqibNGg7OCMqmBkd1j8YGA-rGAlaWYyCRkxiM3i8ySSxYgnWYgk20Ke0Q3W0JgsmkugWq71UtxU7wEnW6vX6gzeIz+AOi0zic1oFGIaQA1pAUrIaAxuMRGdRyVNYrMErSGZAEGy6egCphIZDcjDxUUcaZqIMrKpAqpNLpAsYrHV1NiECYysr1KoPGZas0DGSJhTeSCaXTGRAWPgSKhqOwKGKcMRUABbLnWnnA6kCx3CzDstJinaSnIbLay+H3S46YKmSrNUzNL6mPWmLTUerWSzNJo61xWqJBqn8h1MlawNbS-I7eR3EwdYk-U6mbVBXS6xSIPwKrPpgnpswnSuAyl8uihyDusBg1ioODECi8KXxmWtpOfQvVazvHzKrN63RNQsXTR304Cbyo1Qzm3B2uCiDL1csdcAK3SZAd2hFs4VAYoNGMY4LDqd5YNUOo6g1PMPGOPRtXqc0visUxX2red1xwABXRsAGFZHIP1o1kFgo0wNIwAoAAhUNmGAzY9zAod7hMahjQ8dMTkaHD1AMQc7lRcoeieYJlR+TM8KBGtqEIkiwHIzBKN9ajMFo2lG3YhN93AnFhnKKwBxwnUVTg8SEW0YIujMawfAEJCtEUucQVUsiKLIKjxRYe0GTYuMQNhXYTIQVE8Tg3Q1UsDU1TqPUEOODU3PzQxggCO9PNtOYiPYCAxTAAqwAAFWtfBmUwVkIw5GhuSU+cipK5AyvfKqonwcNIx02MoQ40DIu4tQDDQrMtQzEwGl0PU7zxDR1GNXptR8MT8vfag2tK8ruuwGqXR9d1PWQb0-QDKsWpBXaOv26rUD60VxUG5sIrle4ug6WDlQMUwdSVAG9QqDoB3+ywhNg04tuUu7OprA7GzddgV0WNcNy3JtdxGz61GMbR2l0RC0yfIxNEvU5ji1QT0RNM5Yda4q9q6x7v3R38wAAtIgLC4aPqTZR9FHMSYNqCymgMPMvkVdV2gGFbug0RmQVgIi0gY2BYD01ZDM40bimGUdAiQ3pzhqXNWnuSTLm1fM-C6E4cNCcJ-kDG65mO1AdYMvmjK4-YLg6LLNHeGLPCCPVjSgxCjGNaoXmJFW5nQCh13QCBHBYusnQbbHwsTKLlE0I51CQnpjRLknLD1IX6hvdURz6axEJfP5MGIVJ4A2ZqvKod7C7G5o3EEp4rGjhopattRJIs9ReyDmpUX0ZOEgWZgB+M7jicVQwtG+R5jQuC9p6MPEcyeUPeztgHV4XHPN4DhEy+oA0ziDosWnbGpOjVf7iz0AMC4d9gqOnZhvHGAsor6G0OqTwYlMTvG6PNK2St3CIRWpoPwWo-DqBAYuL8asNZwG7gXLexQYGv1VI8E0n9Uq9B0KoHw3Rx6h0qMYfBOdqBe0fgbRAJc8T5m6ADbsT4KaoNQnNDCDQCbYVwq7Xu5UVJgGIr5TS-ltKD39nwko3xFTj0Qt2LwQQ1SpTqOlL4LwgjDCwQTF24xrp9xoPDB6PVUC8LxqHbQo9fAqknnqJehZxztHWk8AIug74uNZm48BSwPGCxVFBawbw9CHEMIkvMPhjgCL3nUceAgmGROZvdaJh03REM1qQ-mg99h+OoD48efjeh6FSmqdwWYELKmJN0PBCj3ZOJ2sUhGfIkb4G4agV08Si6O1fuqcmGUTitO0GcVEeSEpmAQnfCpJCpncVvJ0N4jwswFIQhcFKVs3gTU6XM6abwrB3x4ZAmpiB4ruEzKiLwWCsRWwqAqFaTRiZeLjvIhxs4lGp3TpnbOn5dmG3MRZWwCUBxWIJrXScioEIO0aI7AYYQwhAA */
    id: 'transferProfile',

    initial: 'binding',

    context: {
      transferStatus: null,
      isLoading: false,
    },

    states: {
      binding: {
        on: {
          approve: 'updateProfileTranser',
          decline: 'refuseConfirmation',

          close: {
            actions: 'logout',
          },
        },
        always: [
          { target: 'alreadyBlocked', cond: 'isTransferDeclined' },
        ],
      },

      blocked: {
        on: {
          close: {
            target: 'binding',
            actions: 'logout',
          },
        },
        invoke: {
          src: 'update profile transfer',
          data: {
            type: () => 'cancel',
          },
          onDone: 'alreadyBlocked',
          onError: 'error',
        },

        states: {
          pending: {
            on: {
              resolve: 'success',
              reject: 'error',
              actions: (context) => (context.isLoading = true),
            },
          },

          success: {
            actions: (context) => (context.isLoading = false),
          },

          error: {
            actions: (context) => (context.isLoading = false),
          },
        },

        initial: 'pending',
      },

      refuseConfirmation: {
        on: {
          cancelBlocking: {
            target: 'binding',
          },
          close: {
            actions: 'logout',
          },
          blocking: 'blocked',
        },
      },

      updateProfileTranser: {
        invoke: {
          src: 'update profile transfer',
          data: {
            type: () => 'accept',
          },
          onDone: 'success',
          onError: 'error',
        },
        states: {
          pending: {
            on: {
              resolve: 'success',
              reject: 'error',
              actions: (context) => (context.isLoading = true),
            },
          },

          success: {
            actions: (context) => (context.isLoading = false),
          },

          error: {
            actions: (context) => (context.isLoading = false),
          },
        },

        initial: 'pending',
      },

      success: {
        on: {
          close: {
            actions: 'reloadPage',
          },
        },
      },

      error: {
        on: {
          close: {
            actions: 'reloadPage',
          },
        },
      },

      alreadyBlocked: {
        on: {
          close: {
            actions: 'logout',
          },
        },
      },
    },
  },
  {
    guards: {
      isTransferDeclined: (context) => {
        return context.transferStatus === STATUS_TRANSFER_DECLINE;
      },
    },
    actions: {
      logout: () => auth.logout(),
      reloadPage: () => window.location.reload(),
    },
    services: {
      'update profile transfer': async (
        ctx,
        event,
        { data: { type } },
      ) => {
        return await api.post('/profile/transfer', { type });
      },
    },
  },
);

export default transferProfile;
